import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

export const DimmerContainer = styled.div`
    position: ${props => props.fullPage ? 'fixed' : 'absolute'};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.8) !important;
    transition-property: opacity;
`;

DimmerContainer.propTypes = {
    fullPage: PropTypes.bool
};